var CryptoJS = require("crypto-js");
export function decryptText(text) {
  var bytes = CryptoJS.AES.decrypt(text, process.env.REACT_APP_DECRYPT_KEY);
  var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  return decryptedData;
}
